import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CoupanServices from '../services/CoupanServices';
import useAsync from '../hooks/useAsync';
import TogelButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import CoupanUpdate from './Update Model/UpdateCoupan';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function CoupanList() {
  const { data, error, isLoading, run } = useAsync(CoupanServices.getCoupan);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleEditDetails = (coupan) => {
    setSelectedEdit(coupan);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (coupan) => {
    setSelectedEdit(coupan);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }


  const filteredData = data?.data?.filter(coupan =>
    coupan.name.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
    coupan.price.toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  const generateExcel = () => {
    const filteredData = data?.data?.map(coupan => ({
      Name: coupan?.name,
      Description: coupan?.description,
      upto: coupan?.upto,
      numberofcoupan: coupan?.numberOfCoupons,
      price: coupan?.price,
      expiredate: formatDateTime(coupan?.endDate),
      date: formatDateTime(coupan?.createdAt),
      status: coupan?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'CoupanData');
    XLSX.writeFile(wb, 'coupan_data.xlsx');
  };
  function truncateText(text, limit) {
    const words = text.split(' ');
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '...';
    }
    return text;
  }
  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Coupon Code List <span className="badge bg-orange">{filteredData?.length || 0}</span>
            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Home Slider Banner Add
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="round-add-btn" to="/add-coupon">
              <img src="img/plus.svg" alt="Add Coupan" />
            </Link>
            <button className="excel-btn" style={{ marginTop: 20 }} onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>

          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    className='form-control'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>NAME OF COUPAN</th>
                  <th className="w-50">DESCRIPTION</th>
                  <th>UP TO 50%</th>
                  <th>NUMBER OF COUPAN</th>
                  <th>AMOUNT</th>
                  <th>EXPIRE DATA</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((coupan, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>

                    <td>{coupan?.name}</td>
                    <td className="address">{truncateText(coupan?.description, 20)}</td>
                    <td>{coupan?.upto}</td>
                    <td>{coupan?.numberOfCoupons}</td>
                    <td>{coupan?.price}</td>
                    <td>{formatDateTime(coupan?.endDate)}</td>
                    <td className="status-toggle">
                      <TogelButtonForStatus data={coupan} page="Coupan" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(coupan)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(coupan)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <CoupanUpdate data={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Coupan" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </>
  );
}

export default CoupanList;
